<template>
    <div>
        <pagamentos
            v-show="mostrarPagamentos"
            :pagamentos="pagamentos"
            :pagamentosServicos="obterPagamentosServicos()"
            :showFornecedor="false"
            @detalhar-pagamento="detalharPagamento($event)"
            @atualizar-listagem="obterPagamentos()"
        >
            <template slot="controles">
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('APPSE-FORN-PAG-02')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharPagamento(data.pagamentoId)"
                    ></i>
                </span>
            </template>
        </pagamentos>
        <router-view></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamentos from '@/app/appsebrae/consultorias/componentes/pagamentos/Pagamentos'

export default {
    data() {
        return {
            pagamentos: [],
            dataInicial: null,
            dataFinal: null,
            setInicial: true
        }
    },

    methods: {
        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentos() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            PagamentosServicos.obterTodos(filtroDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.pagamentos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharPagamento(id) {
            this.$router.push({
                name: `AppSebrae_Consultorias_Fornecedor_Pagamentos_Detalhar`,
                params: {
                    pagamentoId: id
                }
            })
        }
    },

    created() {
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .subtract(1, 'months')
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
        this.setInicial = false
        this.obterPagamentos()
    },

    computed: {
        mostrarPagamentos() {
            return (
                this.$route.name ===
                'AppSebrae_Consultorias_Fornecedor_Pagamentos'
            )
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'AppSebrae_Consultorias_Fornecedor_Pagamentos') {
                if (this.$store.getters.recarregar) {
                    this.obterPagamentos()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
            if (!this.setInicial) {
                this.obterPagamentos()
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
            if (!this.setInicial) {
                this.obterPagamentos()
            }
        }
    },

    components: {
        Pagamentos
    }
}
</script>
